module.exports = __webpack_public_path__ + "img/SER-i-2-III.630a9feb.png";